import { useState } from 'react';

const contactUs = `mail@evapolar.com

EVAPOLAR LTD
236 Strovolou, 
Strovolos, 2048 
Nicosia, Cyprus
`;
const subscribeUserURL = '/api/subscribeUser';

const getUrl = (path) => `https://evapolar.com/${path}`;

export const useFooter = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState({ anim: false, text: '' });
  const setOkStatus = () => {
    setStatus({
      anim: false,
      text: 'Thanks for subscribing',
      error: false,
    });
  };
  const setFailStatus = () => {
    setStatus({
      anim: false,
      text: 'There was an error during the subscription. Please try again.',
      error: true,
    });
  };

  const handleEmailSubmit = async (v) => {
    setStatus({ anim: true, text: '' });

    try {
      const res = await fetch(subscribeUserURL, {
        method: 'POST',
        body: JSON.stringify({ email: v }),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (res.status === 200) {
        setOkStatus();
      } else {
        setFailStatus();
      }
    } catch {
      setFailStatus();
    }
  };

  return {
    email,
    status,
    handleEmailChange: (_, v) => {
      setEmail(v);
    },
    handleEmailSubmit,
    getUrl,
    contactUs,
  };
};
